<script lang="ts">
  import BasicLink from './BasicLink.svelte'
  import DropdownMenu from './DropdownMenu.svelte'
</script>

<DropdownMenu selected="Migliora il tuo impatto" />

<div class="best-practices-wrapper">
  <p class="intro">
    Scopri di più su mezzi alternativi più sostenibili grazie a queste app che esistono sul tuo
    territorio.
  </p>

  <!-- TEMPORARILY DISABLED ON CLIENT REQUEST
    <div class="mezzi-alternativi">
    <h3>Car Pooling</h3>

    <div class="links">
      <BasicLink link="https://www.carpoolworld.com/" title="Carpoolworld" />
      <BasicLink link="https://www.jojobrt.com/carpooler/" title="Jojob" />
      <BasicLink link="https://www.bepooler.com/ch/" title="Bepooler" />
      <BasicLink link="https://www.mobalt.ch/mobalt-app" title="Mobalt" />
      <BasicLink
        link="https://www.blablacar.it/ride-sharing/provincia-di-varese/"
        title="BlaBlaCar"
      />
    </div>
  </div> -->

  <div class="mezzi-alternativi">
    <h3>Offerta locale</h3>

    <div class="links">
      <BasicLink link="http://www.varesesimuove.it/" title="Varese si Muove" />
      <BasicLink
        link="https://play.google.com/store/apps/details?id=com.tplcomoleccovarese.transita"
        title="Transita"
      />
      <!-- TEMPORARILY DISABLED ON CLIENT REQUEST
      <BasicLink link="https://moovitapp.com/milano_e_lombardia-223/poi/fr" title="Moovitapp" />
      <BasicLink link="https://citymapper.com/bologna?lang=es" title="Citymapper" />
      <BasicLink link="http://www.openmove.com/" title="OpenMove" />
      -->
    </div>
  </div>

  <!-- TEMPORARILY DISABLED ON CLIENT REQUEST
    <div class="mezzi-alternativi">
    <h3>Car Sharing</h3>

    <div class="links">
      <BasicLink link="https://www.e-vai.com/" title="E-Vai" />
      <BasicLink link="https://www.mobility.ch/fr/clients-prives" title="Mobility.ch" />
    </div>
  </div> -->

  <!-- TEMPORARILY DISABLED ON CLIENT REQUEST
    <div class="mezzi-alternativi">
    <h3>Ricerca di piste ciclabili</h3>

    <div class="links">
      <BasicLink
        link="https://apps.apple.com/it/app/bikemap-mappa-per-bici-e-gps/
      id625759466"
        title="Bikemap"
      />
    </div>
  </div> -->

  <div class="mezzi-alternativi">
    <h3>Bike Sharing</h3>

    <div class="links">
      <BasicLink
        link="https://www.bicincitta.com/frmLeStazioniComune.aspx?ID=50"
        title="Bicincittà"
      />
      <!-- <BasicLink
        link="https://apps.apple.com/it/app/bikemap-mappa-per-bici-e-gps/
    id625759466"
        title="Bikemap"
      /> -->
      <!-- <BasicLink link="https://www.mobalt.ch/mobalt-app" title="Mobalt" /> -->
    </div>
  </div>

  <div class="mezzi-alternativi">
    <h3>Monopattini</h3>

    <div class="links">
      <BasicLink
        link={'https://play.google.com/store/apps/details?id=com.ridedott.rider&gl=IT'}
        title="Dott"
      />
    </div>
  </div>

  <div class="mezzi-alternativi">
    <h3>Smart Parking</h3>

    <div class="links">
      <BasicLink link="https://easyparkitalia.it/it" title="Easypark" />
    </div>
  </div>

  <div class="mezzi-alternativi">
    <h3>Saperne di più sull’inquinamento</h3>

    <div class="links">
      <BasicLink
        link="https://www.bafu.admin.ch/bafu/en/home/topics/nutrition-housing-mobility/mobility/impacts.html"
        title="(IT-ENG) Confederazione Svizzera"
        subtitle="Impacts of the mobility on the environment"
      />
      <BasicLink
        link="https://www.sciencedirect.com/science/article/pii/S1361920921004235"
        title="(ENG) Mobility as a Service"
        subtitle="The implications of Mobility as a Service for urban emissions"
      />
      <BasicLink
        link="https://www.mite.gov.it/pagina/la-mobilita-sostenibile-nelle-aree-urbane-lattivita-del-ministero-dellambiente-0"
        title="(IT) Ministero dell'Ambiente"
        subtitle="La mobilità sostenibile nelle aree urbane. L’attività del Ministero dell’Ambiente"
      />
      <BasicLink
        link="https://www.enea.it/it/Stampa/comunicati/ambiente-al-via-piattaforma-online-enea-sulla-qualita-dellaria-in-italia/"
        title="(IT) ENEA"
        subtitle="Ambiente: al via piattaforma online ENEA sulla qualità dell’aria in Italia"
      />
    </div>
  </div>
</div>

<style>
  .best-practices-wrapper {
    margin-top: 55px;
    padding: 1rem 2rem;
  }

  .intro {
    color: #7b7b7b;
  }

  .mezzi-alternativi h3 {
    font-size: 20px;
    font-weight: 600;
    padding: 1rem;
    background-color: #313131;
    border-radius: 5px;
  }
</style>
